import { render, staticRenderFns } from "./StudentWarn.vue?vue&type=template&id=fd68f37e&scoped=true"
import script from "./StudentWarn.vue?vue&type=script&lang=js"
export * from "./StudentWarn.vue?vue&type=script&lang=js"
import style0 from "./StudentWarn.vue?vue&type=style&index=0&id=fd68f37e&scoped=true&lang=css"
import style1 from "./StudentWarn.vue?vue&type=style&index=1&id=fd68f37e&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd68f37e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd68f37e')) {
      api.createRecord('fd68f37e', component.options)
    } else {
      api.reload('fd68f37e', component.options)
    }
    module.hot.accept("./StudentWarn.vue?vue&type=template&id=fd68f37e&scoped=true", function () {
      api.rerender('fd68f37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/StudentWarn.vue"
export default component.exports